import React, { FC } from 'react';
import './statusBadge.scss';

interface StatusBadgeProps {
    status: string;
    className?: string;
}

const toSafeClass = (value: string): string => value.toLowerCase().replace(/[^a-z0-9-]/g, '-');

const StatusBadge: FC<StatusBadgeProps> = ({ status, className = '' }) => (
    <span className={`status-badge ${toSafeClass(status)} ${className}`}>{status}</span>
);

StatusBadge.defaultProps = {
    className: '',
};

export default StatusBadge;
